import { Injectable } from '@angular/core';

import { AuthGuard } from '@platform/auth/auth.guard';
import { CompositeGuard } from '@platform/routing/composite.guard';

import { CustomerSpaceAdminGuard } from './customer-space-admin.guard';

@Injectable({
  providedIn: 'root',
})
export class CustomerSpaceAdminCompositeGuard extends CompositeGuard {
  constructor(authGuard: AuthGuard, customerSpaceAdminGuard: CustomerSpaceAdminGuard) {
    super([authGuard, customerSpaceAdminGuard]);
  }
}
